import React from 'react';
import { connect } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import {
  ccsdDefaultChangesBulkCheck,
  ccsdDefaultChangesCheck,
  ccsdDefaultChangesListFetch,
  ccsdDefaultChangesListSetPage,
  ccsdDefaultChangesListUnload,
  ccsdDefaultChangesUncheck,
} from '../../lib/redux/actions/ccsdDefaultChanges';
import MASpinner from '../../components/common/MASpinner';
import Paginator from '../../components/common/Paginator';
import CcsdChangesTable from './CcsdChangesTable';
import CcsdDefaultChangesFilterForm from '../../components/forms/CcsdCode/CcsdDefaultChangesFilterForm';
import { getFiltersFromSession } from '../../lib/routing/filters';

const DEFAULT_FILTERS = {
  'exists[defaultCcsdCodeCost]': true,
  'exists[checkedAt]': false,
  'order[createdAt]': 'asc',
};

const FILTER_ROUTE_KEY = '/ccsd-changes/fee-assured';

const mapStateToProps = (state) => ({
  ...state.ccsdDefaultChanges,
});

const mapDispatchToProps = {
  ccsdDefaultChangesListFetch,
  ccsdDefaultChangesListSetPage,
  ccsdDefaultChangesListUnload,
  ccsdDefaultChangesCheck,
  ccsdDefaultChangesUncheck,
  ccsdDefaultChangesBulkCheck,
};

class CcsdDefaultChangesTab extends React.Component {
  getCombinedFilters() {
    const { filters } = this.props;
    const filtersFromSession = getFiltersFromSession(FILTER_ROUTE_KEY, 'json');
    const merged = { ...DEFAULT_FILTERS, ...filters, ...filtersFromSession };
    Object.keys(merged).forEach((key) => (merged[key] === null || key === 'showChecked') && delete merged[key]);
    return merged;
  }

  componentWillUnmount() {
    this.props.ccsdDefaultChangesListUnload();
  }

  componentDidMount() {
    this.props.ccsdDefaultChangesListFetch(this.props.currentPage, this.getCombinedFilters());
  }

  componentDidUpdate(prevProps) {
    const { currentPage, ccsdDefaultChangesListFetch, filters } = this.props;
    if (prevProps.currentPage !== currentPage || prevProps.filters !== filters) {
      ccsdDefaultChangesListFetch(currentPage, this.getCombinedFilters());
    }
  }

  changePage(page) {
    this.props.ccsdDefaultChangesListSetPage(page);
  }

  nextPage() {
    const { currentPage, pageCount } = this.props;
    this.changePage(Math.min(currentPage + 1, pageCount));
  }

  prevPage() {
    const { currentPage } = this.props;
    this.changePage(Math.max(currentPage - 1, 1));
  }

  render() {
    const {
      ccsdDefaultChanges,
      isFetchingCcsdDefaultChanges,
      pageCount,
      currentPage,
      ccsdDefaultChangesCheck,
      ccsdDefaultChangesUncheck,
      ccsdDefaultChangesBulkCheck,
    } = this.props;

    return (
      <>
        <div className={'mediaccount-filter-wrapper p-3 d-flex justify-content-between align-items-center'}>
          <CcsdDefaultChangesFilterForm
            location={FILTER_ROUTE_KEY}
            onResetPage={() => this.changePage(1)}
          />
          {ccsdDefaultChanges && ccsdDefaultChanges.length > 0 && (() => {
            const uncheckedIds = ccsdDefaultChanges.filter((dc) => !dc.checkedAt).map((dc) => dc.id);
            return (
              <button
                className="btn btn-sm btn-outline-success ml-3 flex-shrink-0"
                disabled={uncheckedIds.length === 0}
                title={`Mark all ${uncheckedIds.length} unchecked item${uncheckedIds.length !== 1 ? 's' : ''} on this page as checked`}
                onClick={() => uncheckedIds.length > 0 && ccsdDefaultChangesBulkCheck(uncheckedIds, currentPage, this.getCombinedFilters())}
              >
                Mark all as checked ({uncheckedIds.length})
              </button>
            );
          })()}
        </div>

        {isFetchingCcsdDefaultChanges && (
          <div className="p-3">
            <MASpinner />
          </div>
        )}

        {!isFetchingCcsdDefaultChanges && (!ccsdDefaultChanges || ccsdDefaultChanges.length === 0) && (
          <div className="p-3">
            <Alert variant={'info'} className="mb-0">
              No fee assured changes found
            </Alert>
          </div>
        )}

        {!isFetchingCcsdDefaultChanges && ccsdDefaultChanges && ccsdDefaultChanges.length > 0 && (
          <CcsdChangesTable
            ccsdChanges={ccsdDefaultChanges}
            onCheck={ccsdDefaultChangesCheck}
            onUncheck={ccsdDefaultChangesUncheck}
          />
        )}

        {!isFetchingCcsdDefaultChanges && ccsdDefaultChanges && ccsdDefaultChanges.length > 0 && (
          <Paginator
            currentPage={currentPage}
            pageCount={pageCount}
            setPage={this.changePage.bind(this)}
            nextPage={this.nextPage.bind(this)}
            prevPage={this.prevPage.bind(this)}
          />
        )}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CcsdDefaultChangesTab);